import { useContext } from 'react';
import { type IRecommendationConfigContextShape } from '../../types/recommendationTypes';
import { RecommendationConfigContext } from '../../contexts/Recommendation/RecommendationConfigContext';

// A custom hook allows us to test better.
export const useRecommendationConfigContext = (): IRecommendationConfigContextShape => useContext(RecommendationConfigContext) as IRecommendationConfigContextShape;

export default useRecommendationConfigContext;
